$(function () {
    setTimezoneCookie();
});

function setTimezoneCookie() {

    var timezone_cookie = "timezoneoffset";
    var currentOffset = (-1) * (new Date().getTimezoneOffset());

    if (!Cookies.get(timezone_cookie)) {

        Cookies.set(timezone_cookie, currentOffset)

        location.reload(); 
    }
    else {
        var storedOffset = parseInt(Cookies.get(timezone_cookie));
       
        if (storedOffset !== currentOffset) {
            Cookies.set(timezone_cookie, currentOffset);
            location.reload();
        }
    }
}